import React from "react";
import {
  Box,
  MenuItem,
  FormControl,
  Select,
  alpha,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { getSuppressionAccountLabels } from "../utils/scheduleNameFormatter";

// Modern shadcn-style Select - compact for header
const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: 160,
  "& .MuiSelect-select": {
    padding: "6px 10px",
    fontSize: "0.8125rem",
    fontWeight: 400,
    borderRadius: "6px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
    color: "#1e293b",
    transition: "all 0.15s ease",
    "&:hover": {
      borderColor: "#d1d5db",
      backgroundColor: "#fafafa",
    },
    "&:focus": {
      borderColor: "#3b82f6",
      boxShadow: `0 0 0 2px ${alpha("#3b82f6", 0.1)}`,
      backgroundColor: "#ffffff",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-icon": {
    color: "#6b7280",
    fontSize: "1.125rem",
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "0.8125rem",
  fontWeight: 400,
  padding: "8px 12px",
  color: "#1e293b",
  borderRadius: "4px",
  margin: "2px 6px",
  "&:hover": {
    backgroundColor: alpha("#3b82f6", 0.08),
    color: "#1e293b",
  },
  "&.Mui-selected": {
    backgroundColor: alpha("#3b82f6", 0.12),
    color: "#1e293b",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: alpha("#3b82f6", 0.16),
    },
  },
}));

const SuppressionFilters = ({
  availableAccountNumbers,
  selectedAccountNumber,
  onAccountChange,
  isAzureView = false,
}) => {
  const accountLabels = getSuppressionAccountLabels(isAzureView);
  return (
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
      {/* Account Number Filter */}
      <FormControl size="small">
        <StyledSelect
          value={selectedAccountNumber || ""}
          onChange={(e) => onAccountChange(e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Box sx={{ color: "#9ca3af", fontWeight: 400, fontSize: "0.8125rem" }}>
                  {accountLabels.noun}
                </Box>
              );
            }
            return (
              <Box sx={{ fontSize: "0.8125rem" }}>{selected}</Box>
            );
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: "6px",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e5e7eb",
                mt: 0.5,
                maxHeight: 300,
              },
            },
          }}
        >
          <StyledMenuItem value="">
            <Box sx={{ color: "#9ca3af", fontStyle: "italic" }}>
              {accountLabels.all}
            </Box>
          </StyledMenuItem>
          {availableAccountNumbers.map((accountNumber) => (
            <StyledMenuItem key={accountNumber} value={accountNumber}>
              {accountNumber}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </Box>
  );
};

export default SuppressionFilters;

